export default function Skill ({ icon, skill }) {
    return (
        <div className="hero-container__skill body-p text-lg px-2 py-1 rounded flex items-center m-1">
            <i className={`fa-brands fa-${icon} mr-2`}/>
            <span>{skill}</span>
        </div>
    )
}